import React, {useState} from 'react';
import ChatTextField from '../components/ChatTextField';
import useMediaQuery from '../hooks/useMediaQuery';
import {useSendChatAnalytic} from '../hooks/useSendChatAnalytic';

interface MessageHandlerProps {
  onSendMessage: (message: string) => void;
}

const MessageHandler: React.FC<MessageHandlerProps> = ({onSendMessage}) => {
  const {isMobile} = useMediaQuery();
  const [inputValue, setInputValue] = useState<string>('');
  const {handleMainSearchInputClick} = useSendChatAnalytic();

  const handleSendMessage = () => {
    if (inputValue.trim() === '') return;
    onSendMessage(inputValue);
    setInputValue('');
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <ChatTextField
      withAnimation={true}
      isMobile={isMobile}
      value={inputValue}
      onKeyDown={handleKeyPress}
      onChange={(str) => setInputValue(str)}
      onFocus={handleMainSearchInputClick}
    />
  );
};

export default MessageHandler;
